<template>
  <div>
    <CRow>
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span className="font-weight-bold h6"><CIcon name="cil-layers" size="lg"/> {{ caption }}</span>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <CSelect :label="$t('nameOfUniversity')"
                         :disabled="disable"
                         :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
                         :options="campus"
                         @update:value="onSelectCampus"
                />
              </CCol>
              <CCol col="12">
                <CSelect :label="$t('department')"
                         :disabled="disable"
                         :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
                         :options="campus"
                         @update:value="onSelectCampus"
                />
              </CCol>
              <CCol col="12">
                <CSelect :label="$t('faculty')"
                         :disabled="disable"
                         :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
                         :options="campus"
                         @update:value="onSelectCampus"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'FilterOption',
  components: {Multiselect},
  props: {
    caption: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      campus: [],
      semesters: [
        {
          label: " 1",
          value: 1
        }, {
          label: " 2",
          value: 2
        }, {
          label: " 3",
          value: 3
        }
      ],
      course: [],

      option: {
        code: null,
        campusId: null,
        semester: 1,
        academicYear: new Date().getFullYear() + 542,
      }
    }


  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.$store.dispatch("campus/config", {})

    },


    onLoadCourses() {
      // this.$store.dispatch("courses/config", this.option)
    },

    onSelectCampus(value, e) {
      this.option.campusId = value;
      this.onLoadCourses();
      this.$emit("option", this.option)
    },

    onSemester(value, e) {
      this.option.semester = value;
      this.onLoadCourses();
      this.$emit("option", this.option)
    },

  },


  computed: {
    ...mapGetters({
      objsLang: "setting/lang",
      objsCampus: "campus/campus",
      objsCourses: "courses/course",
    }),
  },

  watch: {
    objsCampus(value) {
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = item.title.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        var data = {};
        data.label = objs
        data.value = item._id;
        items.push(data)
      })
      this.campus = items;

      this.option.campusId = this.campus[0].value;
      this.onLoadCourses();
    },

    objsCourses(value) {
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = item.title.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        var data = {};
        data.label = item.code + " " + objs + " " + item.credit


        var objs = item;

        data.value = objs;

        items.push(data)
      })
      this.course = items;

    },

    "option.code"(value) {
      this.$emit("option", this.option)
    },
    "option.academicYear"(value) {
      this.$emit("option", this.option)
    }
  }

}
</script>
<style>


</style>
